module.exports = __webpack_public_path__ + "static/media/enteromarlogo.6837b496.png";